import sdl from '@jds/react-generated-sdl/JDSTabBar';
import type { JDSTabBarProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSTabBarProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    overflow = 'scroll',
    kind = 'undefined',
    appearance = 'undefined',
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { overflow, kind, appearance, ...rest },
    'JDSTabBar',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const TabBar = withLogic(Component) as React.FC<JDSTabBarProps> & {
  slotName?: string;
};

TabBar.displayName = 'TabBar';
TabBar.slotName = 'jds_tab_bar';

export { TabBar, type JDSTabBarProps };
